import { AdminStoreDataListEnum } from '@/store/modules/admin/types/AdminStoreDataListEnum';
import store from '@/store/store';
import { ITextValue } from '@/types/common';

const getListByCategory = (category: string) => store?.getters?.['Admin/getListByCategory'](category);

export const getPropertyTypesForFilters = (): ITextValue<string>[] => {
  // should be here, as this function called in getDefaultGroupFilterObjectShape where store is init process
  if (!store) { return []; }

  return getListByCategory(AdminStoreDataListEnum.property_types).items.map((type: string) => ({
    value: type.toLowerCase(),
    text: type,
  }));
}
